import { Badge, IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles(() => ({
  badge: {
    padding: '0 2px 0 0',
  },
  iconButton: {
    marginLeft: '5px',
  },
}));
const badgeStyle = makeStyles(() => ({
  badge: {
    border: 'solid 2px white',
    height: '22px',
    borderRadius: '11px',
    minWidth: '22px',
  },
}));

const NotificationsButton = ({ badge = 0, isNotification = true, ...props }) => {
  const clss = useStyles();
  let classes = {};

  if (isNotification) {
    classes = badgeStyle();
  }

  return (
    <IconButton className={clss.iconButton} {...props} size="large">
      <Badge className={clss.badge} classes={classes} badgeContent={badge} color="primary" overlap="rectangular">
        {isNotification && <i className="di icon-glocke-benachrichtigung" /> }
      </Badge>
    </IconButton>
  );
};

export default NotificationsButton;
